<template>
    <div class="scoreboard" v-if="tournament !== null" :eventId="eventId">
        <table>
            <thead>
                <tr>
                    <td></td>
                    <td><span>{{tournament}}</span></td>
                    <td><span>1</span></td>
                    <td><span>2</span></td>
                    <td><span>3</span></td>
                    <td><span>Sets</span></td>
                    <td><span>Points</span></td>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td :class="[homeTeam.serving ? 'tennisServingOn' : 'tennisServingOff', 'tennisServing']"></td>
                    <td>{{homeName}}</td>
                    <td>{{homeTeam.setOne}}</td>
                    <td>{{homeTeam.setTwo}}</td>
                    <td>{{homeTeam.setThree}}</td>
                    <td>{{homeTeam.setPlayed}}</td>
                    <td style="color:gold;">{{homeTeam.points}}</td>
                </tr>
                <tr>
                    <td :class="[awayTeam.serving ? 'tennisServingOn' : 'tennisServingOff', 'tennisServing']"></td>
                    <td>{{awayName}}</td>
                    <td>{{awayTeam.setOne}}</td>
                    <td>{{awayTeam.setTwo}}</td>
                    <td>{{awayTeam.setThree}}</td>
                    <td>{{awayTeam.setPlayed}}</td>
                    <td style="color:gold;">{{awayTeam.points}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import { HubConnection } from '@aspnet/signalr';
	import { isNullOrUndefined } from 'util';

    export default {
        name: 'Tennis',
        data() {
            return {
                firstSet: 'First Set',
                secondSet: 'Second Set',
                thirdSet: 'Third Set',
                setsPlayed: 'Sets Played',
                points: 'Points',
                tournamentTip: 'Tournament',

                tournament: null,
                homeName: null,
                homeTeam: {
                    serving: null,
                    setOne: null,
                    setTwo: null,
                    setThree: null,
                    setPlayed: null,
                    points: null
                },
                awayName: null,
                awayTeam: {
                    serving: null,
                    setOne: null,
                    setTwo: null,
                    setThree: null,
                    setPlayed: null,
                    points: null
                }
            }
        },
        props: {
            eventId: String,
            connection: HubConnection,
        },
        methods: {
            scoreboardUpdate(updatedScoreboard) {
                if (updatedScoreboard !== null && updatedScoreboard.Sport === "Tennis") {
                    var eventName = updatedScoreboard.EventName.split(" v ");
                    this.homeName = eventName[0];
                    this.awayName = eventName[1];

                    this.homeTeam.setPlayed = updatedScoreboard && updatedScoreboard.GameState && updatedScoreboard.GameState[0] && updatedScoreboard.GameState[0].SetsPlayed;
                    this.awayTeam.setPlayed = updatedScoreboard && updatedScoreboard.GameState && updatedScoreboard.GameState[0] && updatedScoreboard.GameState[0].SetsPlayed;

                    var points = updatedScoreboard && updatedScoreboard.GameState && updatedScoreboard.GameState[0] && updatedScoreboard.GameState[0].Points && updatedScoreboard.GameState[0].Points.split("-");
                    if (points !== isNullOrUndefined) {
                        this.homeTeam.points = points[0];
                        if (points[0].includes("*")) {
                            this.homeTeam.serving = true;
                            this.awayTeam.serving = false;
                            var pointServing = points[0].split("*");
                            this.homeTeam.points = pointServing[1];
                        }
                        this.awayTeam.points = points[1];
                        if (points[1].includes("*")) {
                            this.awayTeam.serving = true;
                            this.homeTeam.serving = false;
                            var pointServingAway = points[1].split("*");
                            this.awayTeam.points = pointServingAway[0];
                        }
                    }


                    this.tournament = updatedScoreboard && updatedScoreboard.GameState && updatedScoreboard.Tournament;

                    var setOne = updatedScoreboard && updatedScoreboard.GameState && updatedScoreboard.GameState[0] && updatedScoreboard.GameState[0].Sets && updatedScoreboard.GameState[0].Sets[0] && updatedScoreboard.GameState[0].Sets[0].SetResult.split("-");
                    if (!isNullOrUndefined(setOne)) {
                        this.homeTeam.setOne = setOne[0];
                        this.awayTeam.setOne = setOne[1];
                    }

                    var setTwo = updatedScoreboard && updatedScoreboard.GameState && updatedScoreboard.GameState[0] && updatedScoreboard.GameState[0].Sets && updatedScoreboard.GameState[0].Sets[1] && updatedScoreboard.GameState[0].Sets[1].SetResult.split("-");
                    if (!isNullOrUndefined(setTwo)) {
                        this.homeTeam.setTwo = setTwo[0];
                        this.awayTeam.setTwo = setTwo[1];
                    }

                    var setThree = updatedScoreboard && updatedScoreboard.GameState && updatedScoreboard.GameState[0] && updatedScoreboard.GameState[0].Sets && updatedScoreboard.GameState[0].Sets[2] && updatedScoreboard.GameState[0].Sets[2].SetResult.split("-");
                    if (!isNullOrUndefined(setThree)) {
                        this.homeTeam.setThree = setThree[0];
                        this.awayTeam.setThree = setThree[1];
                    }
                }
            },
        },
        mounted() {
            if (this.connection) {
                this.connection.on(this.eventId + "_fixtureUpdate", (value) => {
                    this.scoreboardUpdate(JSON.parse(value));
                });
            }
        }


    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .scoreboard {
        margin: 0 auto;
        border: 2px solid white;
        width: 100%;
        margin-bottom: 15px;
        line-height: 25px;
    }

        .scoreboard table {
            width: 100%;
            border-spacing: 0;
        }

			.scoreboard table thead {
				background: #020381;
				width: 100%;
				color: gold;
				font-weight: 600;
			}

                .scoreboard table thead td {
                    padding: 10px;
                    text-align: center;
                }

                    .scoreboard table thead td:first-child {
                        text-align: center;
                        padding: 3px;
                    }
                    .scoreboard table thead td:nth-child(2) {
                        text-align: left;
                        width: 50%;
                    }

            .scoreboard table tbody {
                background: #2b2b2b;
                width: 100%;
            }

                .scoreboard table tbody td {
                    padding: 5px 10px;
                    text-align: center;
                }

                    .scoreboard table tbody td:first-child {
                        padding: 4px;
                    }
                        .scoreboard table tbody td:nth-child(2) {
                             text-align: left;
                        }
    @media (max-width:588px) {
        .scoreboard table tbody td  {
            font-size: 11px;
            padding: 2px;
        }
            .scoreboard table tbody td:first-child {
                padding: 2px;
            }

        .scoreboard table thead td {
            padding: 4px;
            font-size: 11px;
        }
    }
    .tennisServing {
        content: "";
        width: 5px;
        display: block;
        margin: 12px 2px;
        position: absolute
    }

    .tennisServingOn {
        border: 1px solid #303030;
        border-radius: 5px;
        background-color: #2ad100;
    }
    .tennisServingOff {
        border: 1px solid #303030;
        border-radius: 5px;
        background-color: #545454;
    }
</style>



